import React from "react"
import {FormattedMessage, injectIntl} from "react-intl";
import {Button} from "reactstrap";
import ContentUnitHeader from "../../content-unit-header";
import BaseComponent from "../../../base-component";
import {Fade, Zoom} from "react-reveal";
import AttachmentsList from "../../attachments-list";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index";
import InnogyStyleIcon from "../../../innogy-style-icon";
import common_images from "../../../../common-images";
import i2_1 from './i2-1.svg';
import i2_z1 from './i2-z1.svg';
import i2_2 from './i2-2.svg';
import i2_z2 from './i2-z2.svg';
import i2_3 from './i2-3.svg';
import i2_z3 from './i2-z3.svg';
import i2_4 from './i2-4.svg';
import i2_z4 from './i2-z4.svg';
import i2_5 from './i2-5.svg';
import i2_z5 from './i2-z5.svg';
import i2_6 from './i2-6.svg';
import i2_z6 from './i2-z6.svg';
import i2_7 from './i2-7.svg';
import i2_z7 from './i2-z7.svg';

class Interesting extends React.Component {
    render() {
        const imageClass = `col-6 col-md-3 ${this.props.switch ? 'order-md-last' : ''}`;

        return (
            <Zoom>
                <div className='row justify-content-center mt-4'>
                    <div className='col-md-8 mb-2' style={{ borderTop: '1px dashed #009ba5' }}/>
                </div>
                <div className='row justify-content-center align-items-center'>
                    <div className={imageClass}>
                        <img src={this.props.image} className='img-fluid'/>
                    </div>
                    <div className='col-md-5 small'>
                        <p className='font-weight-bold'>Zajímavost</p>
                        <div>{this.props.children}</div>
                    </div>
                </div>
                <div className='row justify-content-center mb-7'>
                    <div className='col-md-8 mt-2' style={{ borderTop: '1px dashed #009ba5' }}/>
                </div>
            </Zoom>
        );
    }
}

class InnogyIntroduction extends BaseComponent {
    render() {
        const { assignment, readOnly } = this.props;
        const contentUnit = assignment.content_unit;
        const state = assignment.state;

        const headerData = {
            title: contentUnit.title,
            category: contentUnit.category,
            type: contentUnit.type,
        };

        const colClassContentLeft = 'col-md-6 d-flex flex-column justify-content-center';
        const colClassContentRight = 'col-md-6 d-flex flex-column justify-content-center';
        const colClassImageLeft = 'col-md-6 mb-3 d-flex flex-column justify-content-center';
        const colClassImageRight = 'col-md-6 mb-3 order-md-last d-flex flex-column justify-content-center';
        const line = (<div className='bg-fiery-fuchsia-bright rounded m-auto flex-grow-1' style={{'width': '5px' }}/>);

        return (
            <div>
                <ContentUnitHeader contentUnit={headerData}/>
                <section className='pb-5'>
                    {
                        contentUnit.description && contentUnit.description.length > 0 &&
                        <div className='container mt-4 mb-4 text-center'>
                            {contentUnit.description}
                        </div>
                    }
                </section>
                <div className='container justify-content-center'>
                    <div className='text-center mb-5 pb-5 text-gray'>
                        <FontAwesomeIcon icon={['far', 'arrow-circle-down']}/><br/>
                        <p>Pro zobrazení sjeď níže</p>
                    </div>
                </div>
                <div className='container mt-5'>
                    <Fade left>
                        <div className='row'>
                            <div className={colClassImageLeft}>
                                <img src={i2_1} className='img-fluid'/>
                            </div>
                            <div className={colClassContentRight}>
                                <h2 className='text-turquoise'>innogy SE</h2>
                                <p>Udáváme trendy moderní energetiky</p>
                                <p>innogy SE vznikla 1. 4. 2016 jako dceřiná společnost RWE AG, je tedy součástí jedné z největších energetických firem v Evropě. Název innogy vznikl spojením slov energie, technologie, inovace, která vyjadřují naše zaměření na moderní evropskou energetiku budoucnosti. Vycházíme tak vstříc požadavkům moderního dekarbonizovaného, decentrálního a digitálního světa energetiky.</p>
                            </div>
                        </div>
                    </Fade>
                    <Interesting image={i2_z1}>
                        Celkem 40 000 zaměstnanců poskytuje naše inovativní produkty a služby celkem 23 milionům zákazníků. To je skoro tolik, jako má dohromady Česká republika, Slovensko a Rakousko obyvatel.
                    </Interesting>

                    <Fade right>
                        <div className='row justify-content-end'>
                            <div className={colClassImageRight}>
                                <img src={i2_2} className='img-fluid'/>
                            </div>
                            <div className={`${colClassContentLeft}`}>
                                <h2 className='text-turquoise'>innogy Česká republika</h2>
                                <p>Energetické srdce innogy v ČR</p>
                                <p>Zabezpečuje a koordinuje veškeré podnikatelské aktivity innogy v České republice prostřednictvím našich dceřiných společností. Současně jim poskytuje specifické odborné činnosti a služby, jako je finanční řízení a řízení rizik, controllingové služby, interní audit, řízení v oblasti bezpečnosti a ochrany osob, majetku a informací, včetně celé agendy bezpečnosti a ochrany zdraví při práci. Dále pak zajištění právních služeb, řízení majetkových účastí či služeb souvisejících s regulačními záležitostmi, veškeré činnosti a služby týkající se oblasti externí a interní komunikace, lidských zdrojů, centrálního nákupu, správy budov, technologické a IT podpory.</p>
                                <p>Společnost innogy Česká republika má téměř 500 zaměstnanců.</p>
                            </div>
                        </div>
                    </Fade>
                    <Interesting image={i2_z2} switch={true}>
                        Svými aktivitami podporuje více než 4100 zaměstnanců. Tolik lidí by téměř zaplnilo 5 největších dopravních letadel na světě - Airbus A380.
                    </Interesting>

                    <Fade left>
                        <div className='row'>
                            <div className={colClassImageLeft}>
                                <img src={i2_3} className='img-fluid'/>
                            </div>
                            <div className={colClassContentRight}>
                                <h2 className='text-turquoise'>innogy Energie</h2>
                                <p>Jednička na trhu s energiemi</p>
                                <p>Zajišťuje spolehlivé dodávky energií pro firmy i domácnosti. innogy Energie je jedničkou na českém trhu s plynem. Je rovněž největší a nejúspěšnější firmou mezi tuzemskými alternativními dodavateli elektřiny.<br/>
                                    Firemním klientům nabízíme produkty a IT řešení, které jim usnadní nákup energií a současně pomohou výrazně ušetřit náklady.</p>
                                <p>V innogy Energie pracuje téměř 250 kolegů a kolegyň.</p>
                            </div>
                        </div>
                    </Fade>
                    <Interesting image={i2_z3}>
                        Staráme se o 1,6 milionu zákazníků. To je víc, než má obyvatel Středočeský kraj.
                    </Interesting>

                    <Fade right>
                        <div className='row justify-content-end'>
                            <div className={colClassImageRight}>
                                <img src={i2_4} className='img-fluid'/>
                            </div>
                            <div className={colClassContentLeft}>
                                <h2 className='text-turquoise'>innogy Energo</h2>
                                <p>Teplo, elektřina a čistá mobilita</p>
                                <p>Po celé ČR vyrábí teplo a elektřinu v teplárenských provozech, které jsou maximálně šetrné k životnímu prostředí. Naším receptem je kombinování výroby elektrické a tepelné energie. Instalujeme fotovoltaické elektrárny a bateriové systémy. Patříme k největším hráčům na trhu CNG a k výrazným propagátorům využívání stlačeného zemního plynu a rozvoje elektromobility. Neustále investujeme do rozšiřování sítě vlastních plniček CNG a poskytujeme poradenství a spolupráci v oblasti čisté mobility.</p>
                                <p>V innogy Energo pracuje přibližně 80 kolegů a kolegyň.</p>
                            </div>
                        </div>
                    </Fade>
                    <Interesting image={i2_z4} switch={true}>
                        V roce 2018 na naších CNG stanicích zákazníci natankovali 5,6 mil. kg zemního plynu. Škoda Octavia G-Tec by na tolik plynu dojela téměř 150krát ze Země k Měsíci a zpět!
                    </Interesting>

                    <Fade left>
                        <div className='row'>
                            <div className={colClassImageLeft}>
                                <img src={i2_5} className='img-fluid'/>
                            </div>
                            <div className={colClassContentRight}>
                                <h2 className='text-turquoise'>innogy Zákaznické služby</h2>
                                <p>Zákazník na prvním místě</p>
                                <p>Našim zákazníkům poskytujeme prvotřídní servis. O jejich spokojenost se starají naši kolegové v široké síti zákaznických center v celé České republice a specialisté kontaktních center v Ostravě, Opavě, Karviné a Zlíně.<br/>
                                    Naši zákazníci nás mohou kontaktovat také přes Skype, on-line chat a videoterminály.</p>
                                <p>Počet zaměstnanců v innogy Zákaznické služby se pohybuje okolo čísla 850.</p>
                            </div>
                        </div>
                    </Fade>
                    <Interesting image={i2_z5}>
                        Naše zákaznická centra ročně navštíví až 400 tisíc zákazníků. To je přibližně tolik lidí, jako má obyvatel Brno.
                    </Interesting>

                    <Fade right>
                        <div className='row justify-content-end'>
                            <div className={colClassImageRight}>
                                <img src={i2_6} className='img-fluid'/>
                            </div>
                            <div className={colClassContentLeft}>
                                <h2 className='text-turquoise'>innogy Grid Holding</h2>
                                <p>Bezpečné a spolehlivé dodávky zemního plynu</p>
                                <p>Zajišťujeme dodávky zemního plynu pro velkou část obyvatel České republiky. Staráme se o bezpečný a bezproblémový provoz a údržbu zařízení na distribuci zemního plynu. Zavádíme nové doplňkové služby pro plnou spokojenost našich koncových zákazníků.</p>
                                <p>V innogy Grid Holding pracuje téměř 2200 zaměstnanců.</p>
                            </div>
                        </div>
                    </Fade>
                    <Interesting image={i2_z6} switch={true}>
                        Spravujeme 2,3 milionu odběrných míst a staráme se o 65 000 km plynovodů - to je více než 1,5 násobek obvodu Země.
                    </Interesting>

                    <Fade left>
                        <div className='row'>
                            <div className={colClassImageLeft}>
                                <img src={i2_7} className='img-fluid'/>
                            </div>
                            <div className={colClassContentRight}>
                                <h2 className='text-turquoise'>innogy Gas Storage</h2>
                                <p>Držíme strategické zásoby zemního plynu</p>
                                <p>Jsme největším provozovatelem podzemních zásobníků zemního plynu v České republice. Disponujeme 6 zásobníky s celkovou kapacitou 2,7 miliardy m3 zemního plynu. Naše zásobníky patří ke strategické infrastruktuře naší země a jsou klíčové pro zajištění plynulých dodávek plynu především v zimních měsících.</p>
                                <p>Společnost innogy Gas Storage zaměstnává téměř 220 kolegů a kolegyň.</p>
                            </div>
                        </div>
                    </Fade>
                    <Interesting image={i2_z7}>
                        Celková kapacita našich zásobníků představuje asi třetinu průměrné roční spotřeby celé České republiky.
                    </Interesting>

                    <AttachmentsList contentUnit={contentUnit}/>
                    {
                        !readOnly && state !== 'complete' &&
                        <div>
                            <hr/>
                            <Button onClick={this.props.markAsDone}><FormattedMessage id='app.actions.mark_as_done'/></Button>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default injectIntl(InnogyIntroduction);
